import { decodePhone } from '../utils/Phone';
import { defaultHttpClient } from './_HttpClient';
export async function IsLoggedIn() {
    const response = await defaultHttpClient.post('/AjaxIsLogin.aspx', {});
    return response.data === '1' || response.data === 1;
}
export async function GetUserInfo() {
    const response = await defaultHttpClient.get("/Ajax/Customer.aspx/Info");
    return response.data;
}
export async function ChangePwd(customerID, oldPwd, newPwd, confirmPwd) {
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/ChangePwd", {
        customerID: customerID,
        oldPwd: oldPwd,
        newPwd: newPwd,
        confirmPwd: confirmPwd
    });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function EmailCheck(email) {
    const resp = await defaultHttpClient.post("/Ajax/Customer.aspx/EmailCheck", { email: email });
    return resp.data;
}
export async function ClearSecEmail(customerID) {
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/ClearSecEmail", { customerID: customerID });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function ClearAccEmail(customerID) {
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/ClearAccEmail", { customerID: customerID });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function ClearSecPhone(customerID) {
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/ClearSecPhone", { customerID: customerID });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function UpdateCustomerSecEmailAndAccEmail(customerID, secondaryEmail, accountingEmail) {
    if (secondaryEmail === undefined) {
        secondaryEmail = "";
    }
    if (accountingEmail === undefined) {
        accountingEmail = "";
    }
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/UpdateCustomerSecEmailAndAccEmail", {
        customerID: customerID,
        secondaryEmail: secondaryEmail,
        accountingEmail: accountingEmail
    });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function UpdateCustomerSecPhone(customerID, secondaryPhone, secondaryPhoneExt) {
    if (secondaryPhone === undefined) {
        secondaryPhone = "";
    }
    if (secondaryPhoneExt === undefined) {
        secondaryPhoneExt = "";
    }
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/UpdateCustomerSecPhone", {
        customerID: customerID,
        secondaryPhone: secondaryPhone,
        secondaryPhoneExt: secondaryPhoneExt
    });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function DeleteCustomerAccount(customerID) {
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/DeleteCustomerAccount", { customerID: customerID });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function DisconnectCustomerFacebook(customerID) {
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/DisconnectCustomerFacebook", { customerID: customerID });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function DisconnectCustomerGoogle(customerID) {
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/DisconnectCustomerGoogle", { customerID: customerID });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function CheckEmail(email) {
    const resp = await defaultHttpClient.post("/Ajax/Customer.aspx/CheckEmail", { email: email });
    const data = resp.data;
    return JSON.parse(data.d);
}
export async function SubmitCustomerInfo(customer) {
    const phone = decodePhone(customer.value.phone);
    const secondPhone = decodePhone(customer.value.secondPhone);
    const submittedUserInfo = {
        id: customer.value.id,
        firstName: customer.value.firstName,
        lastName: customer.value.lastName,
        email: customer.value.email,
        secondaryEmail: customer.value.secondEmail,
        accountingEmail: customer.value.accountEmail,
        phone: phone.phoneValue,
        phoneExt: phone.extValue,
        secondaryPhone: secondPhone.phoneValue,
        secondaryPhoneExt: secondPhone.extValue,
        company: customer.value.company,
        industry: customer.value.industry,
        industryOthers: customer.value.otherIndustry,
        department: customer.value.department,
        departmentOthers: customer.value.otherDepartment,
    };
    const resp = await defaultHttpClient.post("/Ajax/CustomerAccountSettings.aspx/SubmitCustomerInfo", { submittedUserInfo: submittedUserInfo });
    const data = resp.data;
    return JSON.parse(data.d);
}
